import { useMemo, type FC } from 'react';

// Components
import AdminLayout from './admin';
import LoggedLayout from './public';
// import NotificationDrawer from '../notifications/notificationDrawer';

// Redux
import { useAppSelector } from '../../store/store';

// Constants
// import { PERMISSIONS } from '../../constants/permissions';

export const Layout: FC<{ children: any; layout?: string }> = (props) => {
  const user = useAppSelector((state) => state.auth.user);

  const isAdmin = useMemo(() => {
    if (!user) return false;
    return user.roles.some((r) => r.descripcion.includes('ADMIN'));
  }, [user]);

  const CurrentLayout = isAdmin ? AdminLayout : LoggedLayout;

  return (
    <>
      {/* <NotificationDrawer /> */}
      <CurrentLayout {...props} isWhiteLayout={props.layout === 'white'} />
    </>
  );
};
